module.exports = __webpack_public_path__ + "media/images/jeroboam-607939c38698daba614e0f5723859135.svg";